import { Injectable } from "@angular/core";
import {getServers} from "./icesettings";
import { HttpClient } from "@angular/common/http";
import { catchError } from "rxjs";
// import { environment } from "../../environments/environment";
import { EnvironmentService } from "./environment.service";

export async function getServerConfig(backendUrl?: string | undefined) {
  if(!backendUrl) {
    backendUrl = location.origin
  }
  const protocolEndPoint = backendUrl + '/config';
  const createResponse = await fetch(protocolEndPoint);
  return await createResponse.json();
}

@Injectable({
  providedIn: 'root'
})
export class ConfigServerService {

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) {}

  getServerConfig(backendUrl?: string | undefined, connectionId?: string | undefined) {
    return new Promise((resolve, reject) => {
      if(!backendUrl) {
        // if(environment.beHost) {
        //   backendUrl = environment.beHost
        // } else {
        //   backendUrl = location.origin
        // }
        if(this.environmentService.get('beHost')) {
          backendUrl = this.environmentService.get('beHost')
        } else {
          backendUrl = location.origin
        }
      }
      const protocolEndPoint = backendUrl + '/config' + (connectionId ? `?connectionId=${connectionId}` : '');
  
      this.http.get(protocolEndPoint)
      .pipe(
        catchError((err) => {
          console.log(err);
          return [];
        })
      )
      .subscribe(data => {
        resolve(data);
      });
    })
  }

}

export function getRTCConfiguration() {
  let config: any = {};
  config.sdpSemantics = 'unified-plan';
  // config.iceTransportPolicy = "relay";
  config.iceServers = getServers();
  return config;
}
